import { render } from "./PromoList.vue?vue&type=template&id=1183627a&scoped=true"
import script from "./PromoList.vue?vue&type=script&lang=js"
export * from "./PromoList.vue?vue&type=script&lang=js"

import "./PromoList.vue?vue&type=style&index=0&id=1183627a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1183627a"]])

export default __exports__